import {
  SET_CREATE_HPOOL_STEP_FINISHED,
  SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH,
  CREATE_HPOOL_SEARCH_TOKENS_REQUEST,
  CREATE_HPOOL_SEARCH_TOKENS_SUCCESS,
  CREATE_HPOOL_SEARCH_TOKENS_FAILURE,
  CREATE_HPOOL_ADD_TOKEN,
  CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE,
  CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE,
  CREATE_HPOOL_DELETE_TOKEN,
  MANAGE_HPOOL_TAG,
  MANAGE_HPOOL_REPLACE_TOKENS,
  SET_CREATE_TICKETS_ALERT,
  SET_CHOOSE_TOKENS_ALERT,
  GET_CHAMPION_NFT_IMAGE_REQUEST,
  GET_CHAMPION_NFT_IMAGE_SUCCESS,
  GET_CHAMPION_NFT_IMAGE_FAILURE,
  SUBMIT_CREATE_HPOOL_REQUEST,
  SUBMIT_CREATE_HPOOL_SUCCESS,
  SUBMIT_CREATE_HPOOL_FAILURE,
  GET_TAGS_REQUEST,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILURE,
  UPDATE_TAGS,
  GET_HPOOL_SUCCESS,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE,
  GET_CHAMPION_NFT_SUCCESS,
  GET_CHAMPION_DRAFT_POOL_SUCCESS,
  CREATE_UPDATE_HPOOL_SUCCESS,
  CREATE_UPDATE_HPOOL_REQUEST,
  CREATE_UPDATE_HPOOL_FAILURE,
  GET_CHAMPION_NFT_FAILURE,
  GET_CHAMPION_NFT_REQUEST,
  DEPOSIT_HPOOL_REQUEST,
  DEPOSIT_HPOOL_SUCCESS,
  DEPOSIT_HPOOL_FAILURE,
  SET_ASSET_SIGNATURES,
  UPDATE_HPOOL,
  GET_TICKET_INFO_REQUEST,
  GET_TICKET_INFO_SUCCESS,
  GET_TICKET_INFO_FAILURE,
  GET_MIN_DEPOSIT_VALUE_REQUEST,
  GET_MIN_DEPOSIT_VALUE_SUCCESS,
  GET_MIN_DEPOSIT_VALUE_FAILURE,
  ASSIGN_HPOOL_NFT_REQUEST,
  ASSIGN_HPOOL_NFT_SUCCESS,
  ASSIGN_HPOOL_NFT_FAILURE,
  GET_INIT_DEPO_REQUEST,
  GET_INIT_DEPO_SUCCESS,
  RESET_CREATE_HPOOL_ERROR_MESSAGE,
  GET_HPOOL_REQUEST,
  GET_CHAMPION_DRAFT_POOL_REQUEST,
  CLEAR_HPOOL_DRAFT,
  SET_CURRENT_TAB,
  UPDATE_TRADE_ORDERS,
  GET_CHAMPION_DRAFT_POOL_FAILURE,
  FETCH_MOST_USED_TOKENS_REQUEST,
  FETCH_MOST_USED_TOKENS_SUCCESS,
  FETCH_MOST_USED_TOKENS_FAILURE,
  SET_HPOOL_STATS_REQUEST,
  SET_HPOOL_STATS_FAILURE,
  SET_HPOOL_STATS_SUCCESS,
  SET_WHITELISTED_POOLS,
  SET_VPOOL_FLAG,
  UPDATE_BASE_TOKENS,
  GET_HPOOL_SAFTS_SUCCESS,
  GET_HPOOL_SAFTS_REQUEST,
  GET_HPOOL_SAFTS_FAILURE,
  SET_HAS_COMPLETED_SAFTS_STEP,
} from '../actionTypes/createHPoolActionTypes';
import { GET_APP_CONFIG_SUCCESS } from '../actionTypes/generalActionTypes';
import { mixHPoolAssets } from '../../services/createHPoolService';
import { mergeToken, resetAssets } from '../../services/assetsService';

const INITIAL_STATE = {
  completedStepsIds: [],

  chooseTokensAlert: localStorage.getItem('chooseTokensAlert') || 'true',

  hpool: { name: '', description: '' },
  assigningNFT: false,
  tradeOrders: [],
  ticketInfo: { loading: false },
  depoistInfo: { loading: false },
  tags: [], // selected tags

  tagsList: [], // all tags from api
  gettingTagsListData: false,
  gettingTagsListDataError: '',

  createTicketsAlert: localStorage.getItem('createTicketsAlert') || 'true',

  tokensListSearchVal: '',

  searchingTokens: false,
  searchingTokensError: '',
  tokensSearchResults: [],

  unattachedNFT: null,
  gettingUnattachedNFT: false,
  gettingUnattachedNFTError: '',

  gettingNftImage: false,
  gettingNftImageError: '',
  nftImage: null,
  gettingDraftHPool: true,

  creatingHPool: false,
  creatingHPoolError: '',

  depositHPool: null,
  updatingDepositHPool: false,
  updatingDepositHPoolError: '',

  addedTokens: [],

  isFetching: true,
  error: '',

  gettingDepositFundsData: false,
  gettingDepositFundsDataError: '',
  depositFundsUsdLimit: '',

  assetSignatures: {},
  currentInfoTab: '',
  mostUsedTokens: {
    loading: false,
    tokens: [],
  },
  hpoolStats: {
    loading: false,
    state: [],
  },
  vpool: {
    whitelistedUserPools: [],
  },
  isVpool: null,
  poolSafts: {
    saftsArray: [],
    loading: false,
    error: '',
    hasCompletedSaftStep: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  if (type.includes('FAILURE')) {
    console.log('REDUX', action);
  }
  switch (type) {
    case SET_CREATE_HPOOL_STEP_FINISHED: {
      if (state.completedStepsIds.includes(payload)) return state;

      return {
        ...state,
        completedStepsIds: [...state.completedStepsIds, payload],
      };
    }

    case SET_HPOOL_STATS_REQUEST: {
      return {
        ...state,
        hpoolStats: {
          loading: true,
        },
      };
    }
    case SET_HPOOL_STATS_SUCCESS: {
      return {
        ...state,
        hpoolStats: {
          loading: false,
          stats: action.payload,
        },
      };
    }

    case SET_HPOOL_STATS_FAILURE: {
      return {
        ...state,
        hpoolStats: {
          loading: false,
        },
      };
    }

    case GET_MIN_DEPOSIT_VALUE_REQUEST: {
      return {
        ...state,
        depoistInfo: { ...state.depoistInfo, loading: true },
      };
    }

    case GET_MIN_DEPOSIT_VALUE_SUCCESS: {
      return {
        ...state,
        depoistInfo: { ...state.depoistInfo, loading: false, value: payload },
      };
    }

    case GET_MIN_DEPOSIT_VALUE_FAILURE: {
      return {
        ...state,
        depoistInfo: { ...state.depoistInfo, loading: false, error: payload },
      };
    }

    case GET_TICKET_INFO_REQUEST: {
      return {
        ...state,
        ticketInfo: { ...state.ticketInfo, loading: true },
      };
    }

    case GET_TICKET_INFO_SUCCESS: {
      const { numberOfTickets, allocationPerTicket, ...rest } = payload;
      const poolAllocation = +numberOfTickets * +allocationPerTicket;
      return {
        ...state,
        ticketInfo: {
          ...state.ticketInfo,
          info: {
            ...rest,
            poolAllocation,
            numberOfTickets,
            allocationPerTicket,
          },
          loading: false,
        },
      };
    }

    case GET_TICKET_INFO_FAILURE: {
      return {
        ...state,
        ticketInfo: { ...state.ticketInfo, error: payload, loading: false },
      };
    }

    case SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH:
      return { ...state, tokensListSearchVal: payload };

    case CREATE_HPOOL_SEARCH_TOKENS_REQUEST:
      return {
        ...state,
        searchingTokens: true,
        searchingTokensError: '',
      };

    case CREATE_HPOOL_SEARCH_TOKENS_SUCCESS:
      return {
        ...state,
        searchingTokens: false,
        searchingTokensError: '',
        tokensSearchResults: payload,
      };

    case CREATE_HPOOL_SEARCH_TOKENS_FAILURE:
      return {
        ...state,
        searchingTokens: false,
        searchingTokensError: payload,
      };

    case CREATE_HPOOL_ADD_TOKEN:
    case CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE:
    case CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE:
    case CREATE_HPOOL_DELETE_TOKEN:
    case MANAGE_HPOOL_REPLACE_TOKENS:
      return {
        ...state,
        addedTokens: payload,
      };

    case MANAGE_HPOOL_TAG:
      return { ...state, tags: payload, tagsIsLoaded: true };

    case SET_CREATE_TICKETS_ALERT:
      return { ...state, createTicketsAlert: 'false' };

    case SET_CHOOSE_TOKENS_ALERT:
      return { ...state, chooseTokensAlert: 'false' };

    case GET_CHAMPION_NFT_REQUEST:
      return {
        ...state,
        gettingUnattachedNFT: true,
        gettingUnattachedNFTError: '',
      };
    case GET_CHAMPION_NFT_SUCCESS:
      return {
        ...state,
        unattachedNFT: action.payload,
        gettingUnattachedNFT: false,
      };
    case GET_CHAMPION_NFT_FAILURE:
      return {
        ...state,
        gettingUnattachedNFT: false,
        gettingUnattachedNFTError: action.payload,
      };

    case UPDATE_BASE_TOKENS:
      return {
        ...state,
        addedTokens: action.payload,
      };

    case CLEAR_HPOOL_DRAFT:
      return {
        ...state,
        ...INITIAL_STATE,
        addedTokens: action.payload,
        mostUsedTokens: state.mostUsedTokens,
        isVpool: null,
      };

    case GET_CHAMPION_NFT_IMAGE_REQUEST:
      return {
        ...state,
        gettingNftImage: true,
        gettingNftImageError: '',
      };

    case UPDATE_TRADE_ORDERS:
      return {
        ...state,
        tradeOrders: action.payload,
      };

    case GET_CHAMPION_NFT_IMAGE_SUCCESS:
      return {
        ...state,
        gettingNftImage: false,
        gettingNftImageError: '',
        nftImage: payload,
      };

    case GET_CHAMPION_NFT_IMAGE_FAILURE:
      return {
        ...state,
        gettingNftImage: false,
        gettingNftImageError: payload,
      };

    case SUBMIT_CREATE_HPOOL_REQUEST:
      return {
        ...state,
        creatingHPool: true,
        creatingHPoolError: '',
      };

    case SUBMIT_CREATE_HPOOL_SUCCESS:
      return {
        ...state,
        creatingHPool: false,
        creatingHPoolError: '',
      };

    case SUBMIT_CREATE_HPOOL_FAILURE:
      return {
        ...state,
        creatingHPool: false,
        creatingHPoolError: payload,
      };

    case GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST:
      return {
        ...state,
        gettingDepositFundsData: true,
        gettingDepositFundsDataError: '',
      };

    case GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS:
      return {
        ...state,
        gettingDepositFundsData: false,
        gettingDepositFundsDataError: '',
        depositFundsUsdLimit: payload,
      };

    case GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE:
      return {
        ...state,
        gettingDepositFundsData: false,
        gettingDepositFundsDataError: payload,
      };

    case GET_TAGS_REQUEST:
      return {
        ...state,
        gettingTagsListData: true,
        gettingTagsListDataError: '',
      };

    case GET_TAGS_SUCCESS:
      return {
        ...state,
        tagsList: payload.tags,
        gettingTagsListData: false,
        gettingTagsListDataError: '',
      };

    case GET_TAGS_FAILURE:
      return {
        ...state,
        gettingTagsListData: false,
        gettingTagsListDataError: payload,
      };

    case UPDATE_TAGS:
      return {
        ...state,
        tags: payload,
      };

    case ASSIGN_HPOOL_NFT_REQUEST:
      return {
        ...state,
        assigningNFT: true,
        creatingHPoolError: '',
      };
    case ASSIGN_HPOOL_NFT_SUCCESS:
      return {
        ...state,
        assigningNFT: false,
        creatingHPoolError: '',
      };

    case ASSIGN_HPOOL_NFT_FAILURE:
      return {
        ...state,
        assigningNFT: false,
        creatingHPoolError: 'Assigning NFT to your HPool went wrong, Please try again.',
      };
    case FETCH_MOST_USED_TOKENS_REQUEST: {
      return {
        ...state,
        mostUsedTokens: {
          loading: true,
        },
      };
    }
    case FETCH_MOST_USED_TOKENS_SUCCESS: {
      return {
        ...state,
        mostUsedTokens: {
          loading: false,
          tokens: payload.tokens,
        },
      };
    }
    case FETCH_MOST_USED_TOKENS_FAILURE: {
      return {
        ...state,
        mostUsedTokens: {
          loading: false,
          tokens: [],
          error: payload,
        },
      };
    }
    case GET_CHAMPION_DRAFT_POOL_REQUEST: {
      return {
        ...state,
        gettingDraftHPool: true,
      };
    }
    case GET_CHAMPION_DRAFT_POOL_FAILURE: {
      return {
        ...state,
        gettingDraftHPool: false,
      };
    }
    case GET_CHAMPION_DRAFT_POOL_SUCCESS: {
      const { hpool, tradeOrders } = action.payload;
      return {
        ...state,
        gettingDraftHPool: false,
        hpool: hpool || { name: '', description: '' },
        noDrafts: !action.payload,
        addedTokens: action.payload ? mixHPoolAssets(state.addedTokens, hpool.assets) : state.addedTokens,
        tradeOrders: tradeOrders || [],
        draftFetched: true,
      };
    }

    case UPDATE_HPOOL: {
      return {
        ...state,
        hpool: { ...state.hpool, ...payload },
      };
    }

    case CREATE_UPDATE_HPOOL_REQUEST:
      return {
        ...state,
        creatingHPool: true,
        creatingHPoolError: '',
      };
    case CREATE_UPDATE_HPOOL_SUCCESS: {
      const { hpool, tradeOrders } = action.payload;
      return {
        ...state,
        hpool: { ...(state.hpool || {}), ...hpool },
        creatingHPool: false,
        tradeOrders: tradeOrders || [],
      };
    }
    case CREATE_UPDATE_HPOOL_FAILURE:
      return {
        ...state,
        creatingHPool: false,
        creatingHPoolError: action.payload,
      };

    case GET_INIT_DEPO_SUCCESS:
      return {
        ...state,
        hpool: { ...state.hpool, initDepo: payload },
      };
    case DEPOSIT_HPOOL_REQUEST:
      return {
        ...state,
        updatingDepositHPool: true,
        updatingDepositHPoolError: '',
      };
    case DEPOSIT_HPOOL_SUCCESS:
      return {
        ...state,
        depositHPool: action.payload,
        updatingDepositHPool: false,
      };
    case DEPOSIT_HPOOL_FAILURE:
      return {
        ...state,
        updatingDepositHPool: false,
        updatingDepositHPoolError: action.payload,
      };

    case GET_HPOOL_REQUEST:
      return {
        ...state,
        tradeOrders: [],
        isFetching: true,
      };
    case GET_HPOOL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ...action.payload,
        // clear asset signatures when new pool is loaded
        assetSignatures: {},
        error: '',
      };

    case GET_APP_CONFIG_SUCCESS: {
      const addedTokens = Object.values(payload.tokens).map(mergeToken);
      window.configTokens = addedTokens;
      return {
        ...state,
        // addedTokens: payload.required_tokens?.map((symbol) => mergeToken(payload.tokens[symbol])),
        addedTokens,
      };
    }

    case SET_ASSET_SIGNATURES:
      return {
        ...state,
        assetSignatures: { ...state.assetSignatures, ...payload },
      };

    case SET_CURRENT_TAB:
      return {
        ...state,
        currentInfoTab: payload,
      };

    case RESET_CREATE_HPOOL_ERROR_MESSAGE:
      return {
        ...state,
        creatingHPoolError: '',
      };

    case SET_WHITELISTED_POOLS:
      return {
        ...state,
        vpool: {
          whitelistedUserPools: action.payload,
        },
      };

    case SET_VPOOL_FLAG:
      return {
        ...state,
        isVpool: action.payload,
      };

    case SET_HAS_COMPLETED_SAFTS_STEP:
      return {
        ...state,
        poolSafts: {
          ...state.poolSafts,
          hasCompletedSaftStep: true,
        },
      };

    case GET_HPOOL_SAFTS_REQUEST:
      return {
        ...state,
        poolSafts: {
          ...state.poolSafts,
          loading: true,
        },
      };
    case GET_HPOOL_SAFTS_SUCCESS:
      return {
        ...state,
        poolSafts: {
          saftsArray: action.payload,
          loading: false,
        },
      };
    case GET_HPOOL_SAFTS_FAILURE:
      return {
        ...state,
        poolSafts: {
          ...state.poolSafts,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
